import mitt from "mitt"
const emitter = mitt()
module.exports = emitter



// WEBPACK FOOTER //
// ./.cache/emitter.js